import { variant, fields } from 'variant';
import type { VariantOf, TypeNames } from 'variant';

export const SiteState = variant({
  NotConfigured: {},
  Resolved: fields<{ siteId: string }>(),
});

export type SiteState<T extends TypeNames<typeof SiteState> = undefined> =
  VariantOf<typeof SiteState, T>;
